module.exports = __webpack_public_path__ + "d4ef63f7f262c5d78537fee528c2e203.jpg";